import React, { Text } from 'react';
import { useLocation } from 'react-router-dom';

const LocationComponent = (props) => {
    const location = useLocation();
    return <Text location={location} {...props }></Text>
}
export default LocationComponent;